export default __webpack_public_path__ + "static/media/menuL_icon_07.8fa5c3c0.png";